/**
 * The Snowflake objects every install creates, under fixed names. The install
 * SQL and Terraform create them, the backend sends them to the connector in
 * each request context, and the MCP server spec addresses them, so this is
 * the one place they are named.
 */
export const SnowflakeAiObjects = {
  /** P0's database, which holds only the MCP server's schema */
  database: "P0_AI",
  /** P0's schema, unqualified */
  schema: "MCP",
  /** The managed MCP server object, unqualified. Versioned, so a later
   * version can be created next to it rather than changing it in place. */
  mcpServer: "P0_SQL_V1",
  /** The `name` of the server's `SYSTEM_EXECUTE_SQL` tool in its YAML, which
   * is the name agents call it by */
  mcpTool: "sql_exec_tool",
  /** The connector's `TYPE = SERVICE` user */
  connectorUser: "P0_AI_CONNECTOR",
  /** The connector's role, granted USERADMIN and SECURITYADMIN */
  connectorRole: "P0_AI_CONNECTOR",
  /** The XSMALL, auto-suspending warehouse the connector lists objects with */
  warehouse: "P0_AI_WH",
  /** The authentication policy every agent user gets, unqualified: token
   * sign-in only, and a token Snowflake accepts without a network policy */
  agentAuthPolicy: "P0_AGENT_AUTH",
} as const;

/** `P0_AI.MCP` */
export const snowflakeAiSchemaName = `${SnowflakeAiObjects.database}.${SnowflakeAiObjects.schema}`;

/** `P0_AI.MCP.P0_AGENT_AUTH` */
export const snowflakeAiAgentAuthPolicyName = `${snowflakeAiSchemaName}.${SnowflakeAiObjects.agentAuthPolicy}`;

/** `P0_AI.MCP.P0_SQL_V1` */
export const snowflakeAiMcpServerName = `${snowflakeAiSchemaName}.${SnowflakeAiObjects.mcpServer}`;
